export const appEnvironment = {
    apiClient: (process.env.REACT_APP_API_CLIENT || 'localStorage'),
    shopwareAccessKey: (process.env.REACT_APP_SHOPWARE_ACCESS_KEY || 'NO_ACCESS_KEY_CONFIGURED'),
    shopwarePublicUrl: (process.env.REACT_APP_SHOPWARE_PUBLIC_URL || 'https://www.seyfert-lichtdesign.de')
}


